<template>
  <div class="footerH5">
    <div class="tryOut">
      <div class="text">
        立即注册，即可免费试用核心产品，开启您的互联网运维经营之旅。
      </div>
      <div class="btn" @click="goto">免费试用</div>
    </div>
    <div class="menu">
      <div class="menu-two" v-for="item of menuList" :key="item.table">
        <div class="menu-box" @click.stop="changeItem(item)">
          <div>{{ item.table }}</div>
          <img class="back" :src="item.isStyle ? backR : backB" alt="" />
        </div>
        <dir class="menu-children-box" v-if="item.isStyle">
          <div
            class="menu-children"
            v-for="children of item.children"
            :key="children.table"
          >
            {{ children.table }}
          </div>
        </dir>
      </div>
    </div>
    <div class="foot">
      <div class="phone" @click="phone">联系我们：400-086-1123</div>
      <div class="bottom-text1">
        Copyright © 2020 — 2024 东莞市丰派软件科技有限公司
      </div>
      <div class="filing">
        <span @click="openHred"> 粤ICP备19023742号-2 </span>
        <div @click="openHred1" class="gongan-box">
          <img src="~@/assets/gongan.png" class="gongan" alt="" />
          <span>粤公网安备44190002006124号</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import backB from "@/assets/back.png";
import backR from "@/assets/back-r.png";

export default {
  data() {
    return {
      backB,
      backR,
      menuList: [
        {
          table: "产品介绍",
          isStyle: false,
          children: [
            {
              table: "丰派云POS",
            },
            {
              table: "智慧零售",
            },
            {
              table: "订货平台",
            },
          ],
        },
        {
          table: "解决方案",
          isStyle: false,

          children: [
            {
              table: "丰派云POS",
            },
            {
              table: "智慧零售",
            },
            {
              table: "订货平台",
            },
          ],
        },
        {
          table: "帮助和支持",
          isStyle: false,

          children: [
            {
              table: "丰派云POS",
            },
            {
              table: "智慧零售",
            },
            {
              table: "订货平台",
            },
          ],
        },
        {
          table: "应用下载",
          isStyle: false,
          children: [
            {
              table: "丰派云POS",
            },
            {
              table: "智慧零售",
            },
            {
              table: "订货平台",
            },
          ],
        },
      ],
    };
  },
  methods: {
    changeItem(item) {
      this.menuList.forEach((Element) => {
        if (Element.table == item.table) {
          this.$set(Element, "isStyle", !Element.isStyle);
        } else {
          this.$set(Element, "isStyle", false);
        }
      });
    },
    phone() {
      window.location.href = "tel:400-086-1123";
    },
    openHred() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index");
    },
    goto(){
      window.open("https://www.fp1123.com/fpPos/#/regist",'_self');

    },
    openHred1() {
      window.open(
        "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44190002006124"
      );
    },
  },
};
</script>

<style lang="less" scoped>
.footerH5 {
  background: #f5f7fa;
  .tryOut {
    width: 750px;
    height: 318px;
    background: url("~@/assets/tryOut.png") no-repeat;
    background-size: 100% 100%;
    padding: 64px 37.5px;
    .text {
      font-size: 28px;
      line-height: 40px;
      color: #fff;
    }
    .btn {
      margin-top: 30px;
      width: 176px;
      height: 70px;
      margin-left: 2px;
      border: 1px solid #ffffff;
      filter: drop-shadow(8px 8px 20px rgba(55, 99, 170, 0.1));
      border-radius: 6px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .menu {
    display: flex;
    flex-direction: column;
    .menu-two {
      .menu-box {
        width: 750px;
        height: 116px;
        display: flex;
        align-items: center;
        padding: 24px;
        color: #292929;
        font-size: 32px;
        background: linear-gradient(180deg, #f3f5f8 0%, #ffffff 100%);
        border: 4px solid #ffffff;
        // box-shadow: 8px 8px 20px rgba(11, 39, 84, 0.1), 0px -1px 0px #e5e5e5;
        justify-content: space-between;
        .back {
          width: 44px;
          height: 44px;
        }
      }
      .menu-children-box {
        padding: 20px 0;
        width: 750px;
        .menu-children {
          display: flex;
          align-items: center;
          width: 750px;
          padding-left: 80px;
          height: 80px;
          font-size: 30px;
          color: #3d485d;
        }
      }
    }
  }
  .foot {
    padding: 64px 55px;
    width: 750px;
    .phone {
      background: linear-gradient(180deg, #f3f5f8 0%, #ffffff 100%);
      border: 4px solid #ffffff;
      box-shadow: 8px 8px 20px rgba(11, 39, 84, 0.1);
      border-radius: 4px;
      width: 640px;
      height: 88px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 32px;
      color: #292929;
    }
    .bottom-text1 {
      margin-top: 40px;
      color: #3d485d;
      font-size: 24px;
      text-align: center;
    }
    .filing {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      .gongan-box {
        margin-left: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/h5/footerH5.vue